import React, { Component, useEffect } from 'react';
import axios from "axios";
import _ from 'lodash';
import { connect } from 'react-redux';
import clone from 'clone';
import { Link } from 'react-router-dom';
import { Layout, Badge } from 'antd';
import getCommunityFeatureList from './options3';
import Scrollbars from '../../components/utility/customScrollBar.js';
import Menu from '../../components/uielements/menu';
import IntlMessages from '../../components/utility/intlMessages';
import SidebarWrapper from './sidebar.style';
import appActions from '../../redux/app/actions';
import Logo from '../../components/utility/logo';
import icon_new from '../../image/icon_new2.png';
import Config from "../../settings/urbanice-api";
import { siteConfig } from "../../settings";
import { notification } from "../../components/index";

const SubMenu = Menu.SubMenu;
const { Sider } = Layout;
let options = null;
const DEBUG = siteConfig.DEBUG;
const GET_USER_NOTIFICATION = Config.GET_USER_NOTIFICATION;

const {
  toggleOpenDrawer,
  changeOpenKeys,
  changeCurrent,
  toggleCollapsed
} = appActions;
const stripTrailingSlash = str => {
  if (str.substr(-1) === '/') {
    return str.substr(0, str.length - 1);
  }
  return str;
};

class Sidebar extends Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
    this.onOpenChange = this.onOpenChange.bind(this);
    this.state = {
      userToken: "",
      communityID: "",
      isLoading: false,
      userNotificationCountList: [],
      userNotificationCountNitiList: {},
      didNotificationList: "",
    }

    // this.state.userNotificationCountNitiList = JSON.parse(localStorage.getItem('userNotificationCountNitiList'));
    this.state.didNotificationList = JSON.parse(localStorage.getItem('didNotificationList'));

    this.state.userToken = localStorage.getItem("access_token");
    DEBUG && console.log("UserToken: " + this.state.userToken);

    this.state.communityID = localStorage.getItem("communityID");
    DEBUG && console.log("communityID: " + this.state.communityID);
  }

  /********* GET DERIVED STATE FROM PROPS *********/
  static getDerivedStateFromProps(nextProps, prevState) {
    options = getCommunityFeatureList();
  }

  /****** COMPONENT DID UPDATE FUNCTIONS ******/
  componentDidUpdate(prevProps, prevState) {
    DEBUG && console.log("componentDidUpdate");
    // DEBUG && console.log(`prevProps_didNotificationList ${JSON.stringify(prevState.didNotificationList)}`);
    // DEBUG && console.log(`thisProps_didNotificationList ${JSON.stringify(this.state.didNotificationList)}`);
    // if (this.state.didNotificationList !== prevState.didNotificationList) {
    //   this.getUserNotification();
    // }
  }

  /****** COMPONENT DID MOUNT FUNCTIONS ******/
  // componentDidMount() {
  //   this.getUserNotification();
  //   localStorage.setItem('didNotificationList', Date.now() + '');
  //   window.addEventListener('storage', () => {
  //     alert('localstorage changed!')
  //     DEBUG && console.log('getNotiBadge_userNotificationCountNitiList:',JSON.parse(localStorage.getItem('userNotificationCountNitiList')));
  //     DEBUG && console.log('getNotiBadge_didNotificationList:',JSON.parse(localStorage.getItem('didNotificationList')));
  //   })

  // }

  /********* HANDEL CLICK *********/
  handleClick(e) {
    // this.getUserNotification();
    this.props.changeCurrent([e.key]);
    if (this.props.app.view === 'MobileView') {
      setTimeout(() => {
        this.props.toggleCollapsed();
        this.props.toggleOpenDrawer();
      }, 100);
    }
  }

  onOpenChange(newOpenKeys) {
    const { app, changeOpenKeys } = this.props;
    const latestOpenKey = newOpenKeys.find(
      key => !(app.openKeys.indexOf(key) > -1)
    );
    const latestCloseKey = app.openKeys.find(
      key => !(newOpenKeys.indexOf(key) > -1)
    );
    let nextOpenKeys = [];
    if (latestOpenKey) {
      nextOpenKeys = this.getAncestorKeys(latestOpenKey).concat(latestOpenKey);
    }
    if (latestCloseKey) {
      nextOpenKeys = this.getAncestorKeys(latestCloseKey);
    }
    changeOpenKeys(nextOpenKeys);
  }
  getAncestorKeys = key => {
    const map = {
      sub3: ['sub2']
    };
    return map[key] || [];
  };


  /***** HANDLE GET USER NOTIFICATION FUNCTIONS *****/
  getUserNotification = () => {
    DEBUG && console.log("GET_USER_NOTIFICATION ...");
    DEBUG && console.log(`GET_USER_NOTIFICATION_USER_TOKEN: ${this.state.userToken}`);
    DEBUG && console.log(`GET_USER_NOTIFICATION_COMM_ID: ${this.state.communityID}`);

    this.setState({ isLoading: true });

    let axiosConfig = {
      headers: {
        "Content-Type": "application/json; charset=utf-8",
        Authorization: "Bearer " + this.state.userToken
      }
    };

    try {
      axios
        .get(GET_USER_NOTIFICATION + "?communityID=" + this.state.communityID, axiosConfig)
        .then(response => {
          DEBUG && console.log("GET_USER_NOTIFICATION_RESPONSE: ", response);
          DEBUG && console.log('GET_USER_NOTIFICATION_RESPONSE_STATUS: ', response.status);
          DEBUG && console.log('GET_USER_NOTIFICATION_RESPONSE_DATA: ', response.data);
          DEBUG && console.log('GET_USER_NOTIFICATION_RESPONSE_DATA_item: ', response.data.userNotificationCountList);
          DEBUG && console.log('GET_USER_NOTIFICATION_RESPONSE_DATA_Niti: ', response.data.userNotificationCountList.find(item => item.appName === 'urbanice-mobile-niti'));

          if (response.status === 200 || response.status === 201) {
            this.setState({
              userNotificationCountList: response.data.userNotificationCountList,
              userNotificationCountNitiList: response.data.userNotificationCountList.find(item => item.appName === 'urbanice-mobile-niti'),
              isLoading: false,
            });
            localStorage.setItem('userNotificationCountNitiList', JSON.stringify(response.data.userNotificationCountList.find(item => item.appName === 'urbanice-mobile-niti')));
          } else {
            DEBUG && console.log("Error", "ดาวน์โหลดข้อมูลไม่สำเร็จ: " + response.data.errorMessage);
            this.setState({
              isLoading: false,
            }, () => {
              DEBUG && console.log(`isLoading:false`);
              notification('error', "ดาวน์โหลดข้อมูลไม่สำเร็จ: " + response.data.errorMessage);
            });
          }
        })
        .catch(error => {
          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            DEBUG && console.log(error.response.data);
            DEBUG && console.log(error.response.status);
            DEBUG && console.log(error.response.headers);
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            DEBUG && console.log(`Error: ${error.request}`);
            this.setState({
              isLoading: false,
            }, () => {
              DEBUG && console.log(`isLoading:false`);
              notification('error', 'INTERNET DISCONNECTED');
            });
          } else {
            // Something happened in setting up the request that triggered an Error
            DEBUG && console.log('Error', error.message);
            this.setState({
              isLoading: false,
            }, () => {
              DEBUG && console.log(`isLoading:false`);
              notification('error', 'INTERNET DISCONNECTED');
            });
          }
          DEBUG && console.log(error.config);
        });

    } catch (error) {
      DEBUG && console.log(`Axios Request failed:${error}`);
    }
    DEBUG && console.log("FETCH FUCNTION - END");
  }

  /* RENDER MENU ITEM */
  renderMenuItem = (item) => {
    const { userNotificationCountNitiList } = this.state;
    DEBUG && console.log(`renderMenuItem_userNotificationCountNitiList: ${JSON.stringify(userNotificationCountNitiList)}`);
    switch (item) {
      // case 'sidebar.chatPage':
      //   return (
      //     <div>
      //       <IntlMessages id={item} />
      //       <span>
      //         {!_.isEmpty(userNotificationCountNitiList) && userNotificationCountNitiList.chatNitiCount != 0 ?
      //           <span>
      //             <Badge dot offset={[0, -12]} > </Badge>
      //             {" "}<img src={icon_new} width='24px' alt="Logo" />
      //           </span>
      //           :
      //           <span>
      //             {" "}<img src={icon_new} width='24px' alt="Logo" />
      //           </span>
      //         }
      //       </span>
      //     </div>
      //   )
      //   break;
      // case 'sidebar.repairPage':
      //   return (
      //     <div>
      //       <IntlMessages id={item} />
      //       <span>
      //         {!_.isEmpty(userNotificationCountNitiList) && userNotificationCountNitiList.repairRequestCount != 0 ?
      //           <span>
      //             <Badge dot offset={[0, -12]} > </Badge>
      //             {" "}<img src={icon_new} width='24px' alt="Logo" />
      //           </span>
      //           :
      //           <span>
      //             {" "}<img src={icon_new} width='24px' alt="Logo" />
      //           </span>
      //         }
      //       </span>
      //     </div>
      //   )
      //   break;
      case 'sidebar.issueTracking':
        return (
          <div>
            <IntlMessages id={item} />
            <span>
              {!_.isEmpty(userNotificationCountNitiList) && userNotificationCountNitiList.issueTrackingCount != 0 ?
                <span><Badge dot offset={[-4, -8]}></Badge></span> : null
              }
            </span>
          </div>
        )
        break;
      case 'sidebar.suggestion':
        return (
          <div>
            <IntlMessages id={item} />
            <span>
              {!_.isEmpty(userNotificationCountNitiList) && userNotificationCountNitiList.suggestionCount != 0 ?
                <span><Badge dot offset={[-4, -8]}></Badge></span> : null
              }
            </span>
          </div>
        )
        break;
      case 'sidebar.facilityBooking':
        return (
          <div>
            <IntlMessages id={item} />
            <span>
              {!_.isEmpty(userNotificationCountNitiList) && userNotificationCountNitiList.facilityBookingCount != 0 ?
                <span><Badge dot offset={[-4, -8]} ></Badge></span> : null
              }
            </span>
          </div>
        )
        break;
      case 'sidebar.vmsPage':
        return (
          <div>
            <IntlMessages id={item} />
            <span>
              {" "}<img src={icon_new} width='24px' alt="Logo" />
            </span>
          </div>
        )
        break;
      case 'sidebar.patrolPage':
          return (
            <div>
              <IntlMessages id={item} />
              <span>
                {" "}<img src={icon_new} width='24px' alt="Logo" />
              </span>
            </div>
          )
          break;
      case 'sidebar.incidentPage':
        return (
          <div>
            <IntlMessages id={item} />
            <span>
              {" "}<img src={icon_new} width='24px' alt="Logo" />
            </span>
          </div>
        )
        break;
      case 'sidebar.losservicesPage':
          return (
            <div>
              <IntlMessages id={item} />
              <span>
                {" "}<img src={icon_new} width='24px' alt="Logo" />
              </span>
            </div>
          )
          break;
      default:
        return (
          <IntlMessages id={item} />
        )
        break;
    }


  }

  getMenuItem = ({ singleOption, submenuStyle, submenuColor }) => {
    const { key, label, leftIcon, isEnable, isVisible, children } = singleOption;
    const url = stripTrailingSlash(this.props.url);
    if (isVisible) { //isEnable, isVisible
      // DEBUG && console.log(`label: ${label}`)
      if (children) {
        return (
          <SubMenu
            key={key}
            title={
              <span className="isoMenuHolder" style={submenuColor}>
                {/* <i className={leftIcon} /> */}
                {leftIcon}
                <span className="nav-text">
                  <IntlMessages id={label} />
                  {
                    //DEBUG && console.log(`label: ${label}`)
                    label === 'sidebar.repairPage' ?
                      <span>
                        {" "}<img src={icon_new} width='24px' alt="Logo" />
                      </span>
                      : null
                  }
                </span>
              </span>
            }
          >
            {children.map(child => {
              const linkTo = child.withoutDashboard
                ? `/${child.key}`
                : `${url}/${child.key}`;
              return (
                <Menu.Item style={submenuStyle} key={child.key}>
                  <Link style={submenuColor} to={linkTo}>
                    <IntlMessages id={child.label} />
                    {/* {
                    // DEBUG && console.log(`child.label: ${child.label}`)
                    child.label === 'sidebar.parcelImport' ?
                    <span>
                      {" "}<img src={icon_new} width='26px' alt="Logo" />
                    </span>
                     : null
                    } */}
                  </Link>
                </Menu.Item>
              );
            })}
          </SubMenu>
        );
      }
      return (
        <Menu.Item key={key}>
          <Link to={`${url}/${key}`}>
            <span className="isoMenuHolder" style={submenuColor}>
              {leftIcon}
              <span className="nav-text">
                {this.renderMenuItem(label)}
              </span>
            </span>
          </Link>
        </Menu.Item>
      );
    }
  };
  render() {
    const { isLoading } = this.state;
    const { app, toggleOpenDrawer, customizedTheme, height } = this.props;
    const collapsed = clone(app.collapsed) && !clone(app.openDrawer);
    const { openDrawer } = app;
    const mode = collapsed === true ? 'vertical' : 'inline';
    const onMouseEnter = event => {
      if (openDrawer === false) {
        toggleOpenDrawer();
      }
      return;
    };
    const onMouseLeave = () => {
      if (openDrawer === true) {
        toggleOpenDrawer();
      }
      return;
    };
    // const customizedTheme = themes[themeConfig.theme];
    const styling = {
      backgroundColor: customizedTheme.backgroundColor
    };
    const submenuStyle = {
      backgroundColor: 'rgba(0,0,0,0.3)',
      color: customizedTheme.textColor,
      fontFamily: 'Kanit'
    };
    const submenuColor = {
      color: customizedTheme.textColor
    };
    return (
      <SidebarWrapper>
        <Sider
          trigger={null}
          collapsible={true}
          collapsed={collapsed}
          width={240}
          className="isomorphicSidebar"
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
          style={styling}
        >
          {/* {isLoading ? null :
          <div> */}
          <Logo collapsed={collapsed} />
          <Scrollbars style={{ height: height - 70 }}>
            <Menu
              onClick={this.handleClick}
              theme="dark"
              className="isoDashboardMenu"
              mode={mode}
              openKeys={collapsed ? [] : app.openKeys}
              selectedKeys={app.current}
              onOpenChange={this.onOpenChange}
              defaultOpenKeys={['parcelPage']}
            >
              {options.map(singleOption =>
                this.getMenuItem({ submenuStyle, submenuColor, singleOption })
              )}
            </Menu>
          </Scrollbars>
          {/* </div>
  } */}
        </Sider>
      </SidebarWrapper>
    );
  }
}

export default connect(
  state => ({
    app: state.App,
    customizedTheme: state.ThemeSwitcher.sidebarTheme,
    height: state.App.height
  }),
  { toggleOpenDrawer, changeOpenKeys, changeCurrent, toggleCollapsed }
)(Sidebar);
